module.exports = __webpack_public_path__ + "static/media/sharingSingleAccount.05fbdda4.png";